require('./bootstrap')
require('./map')

// Import page-specific components
require('./components/how-it-works')
require('./components/home-page')
require('./components/listing-page')

$('.section-1 .inner').removeClass('hidden');

$(document).ready(() => {
    $('.toggle-menu').click(() => {
        $('.hamburger').toggleClass('is-active')
        $('.menu-mobile').toggleClass('is-active')
        $('body').toggleClass('no-scroll')
    })
})

// google autocomplete
// Note: the listing create/edit address field (#google-autocomplete) is
// initialized by resources/views/partials/listing-address-picker.blade.php,
// which also lets the host pick a street/suburb/city precision. Do not bind
// another Autocomplete instance to it here - two instances on the same
// input fight over which "types" restriction wins.
function initAutocomplete() {
    var optionsSearch = {
        types: ['(regions)'],
        componentRestrictions: {country: 'nz'}
    }
    var inputSearch = document.getElementById('search-autocomplete')
    if (inputSearch) {
        var autocompleteSearch = new google.maps.places.Autocomplete(inputSearch, optionsSearch)
    }

}
if (typeof google != 'undefined') {
    initAutocomplete();
}

$watchHowItWorks = $('#watch-how-it-works');

if ($watchHowItWorks.length) {
    $watchHowItWorks.magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
}

window.getQueryString = function(field, url) {
    var href = url
        ? url
        : window.location.href;
    var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string
        ? string[1]
        : '';
};

window.updateQueryString = function(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        return uri + separator + key + "=" + value;
    }
}

$('.home-page .btn-search').click(function() {
    let location = $('#search-autocomplete').val();
    location = location.split(',')[0];
    $(this).attr('href', updateQueryString($(this).attr('href'), 'location', location));
})


if ($('.listing-images').length && $('.listing-images img').length > 1) {
    let carouselOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
        draggable: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        infinite: true
    };

    $('.listing-images').slick(carouselOptions);
}

if ($('.reviews-carousel').length) {
    let carouselOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
        dots: true,
        draggable: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        infinite: true
    };

    $('.reviews-carousel').slick(carouselOptions);
}

$('[data-toggle="tooltip"]').tooltip()

window.openLoginModal = () => {
    $("#login").modal('show');
}

window.disableSubmitButton = (event) => {
    var button = event.target;
    var form = button.form;

    if (form.checkValidity()) {
        button.disabled = true;
        form.className += ' loading-spinner';
        form.submit();
    }
}
